import React, {useEffect, useState} from 'react';
import {Button, TextField} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {AppName, Device} from '../Redux/Types';
import './Form.scss';

export interface FormProps {
    entity: AppName;
    deviceList: Device[];
    errors: { [key: string]: string };
    onCancelHandler: () => void;
    onSaveHandler: (entity: Partial<AppName>) => void;
}

export default (props: FormProps) => {
    const {entity, deviceList, errors, onCancelHandler, onSaveHandler} = props;
    const [name, setName] = useState<string>(entity.name);
    const [nameError, setNameError] = useState<string>('');
    const [devices, setDevices] = useState<string[]>(entity.devices || []);
    const platforms = Array.from(new Set(deviceList.filter((device) => !devices.some((d) => d === device.platform)).map((d) => d.platform)));
    
    const handleNameChange = (value: string) => {
        if (/^[a-z0-9]*$/.test(value)) {
            setName(value);
            setNameError('');
        }
    };
    
    const handleSubmit = () => {
        onSaveHandler({
            name,
            devices,
        });
    };
    
    useEffect(() => {
        if (errors && 'name' in errors) {
            setNameError(errors.name);
        }
    }, [errors]);
    
    useEffect(() => {
        setNameError('');
    }, []);
    
    return (
        <div className="app-name">
            <div className="app-name__title">CREATE APP PROFILE</div>
            
            <form>
                <div className="app-name__field">
                    <div className="app-name__label">Device Name:</div>
                    <TextField
                        onChange={(event) => handleNameChange(event.target.value)}
                        onBlur={() => {
                            if (!name) {
                                setNameError('App name is required');
                            }
                        }}
                        value={name}
                        className="app-name__input"
                        id="name"
                        name="name"
                        label="Name"
                        variant="outlined"
                        error={nameError !== ''}
                        helperText={nameError}
                    />
                </div>
                
                <div className="app-name__field">
                    <div className="app-name__label">Associated Devices:</div>
                    <Autocomplete
                        multiple
                        id="devices"
                        fullWidth
                        className="app-name__devices"
                        options={platforms}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option}
                        onChange={(event, value) => setDevices(value)}
                        style={{
                            width: '500px',
                        }}
                        renderInput={(params) => (
                            <TextField
                                /* eslint-disable react/jsx-props-no-spreading */
                                {...params}
                                variant="outlined"
                                placeholder="Device"
                            />
                        )}
                    />
                </div>
                
                <div className="app-name__buttons">
                    <Button
                        className="app-name__buttons_cancel"
                        onClick={onCancelHandler}
                        variant="contained"
                    >
                        Cancel
                    </Button>
                    <Button
                        type="button"
                        disabled={name === ''}
                        variant="contained"
                        onClick={handleSubmit}
                    >
                        Create
                    </Button>
                </div>
            </form>
        </div>
    );
};
